import React from 'react';
import styled from '@emotion/styled';
import css from '@styled-system/css';
import { variant } from 'styled-system';

import sx from '../../internal/styles/sx';

const StyledSemanticDrawerHeader = styled('div')(
  css({
    width: '100%',
    height: 60,
    position: 'relative',
    bg: 'green.20',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderTopLeftRadius: 1,
    borderTopRightRadius: 1,
    borderRadius: '8px 8px 80% 80%',
    boxShadow: '10',
  }),
  variant({
    prop: 'type',
    variants: {
      positive: {
        backgroundColor: 'green.20',
      },
      informative: {
        backgroundColor: 'blue.20',
      },
      warning: {
        backgroundColor: 'orange.20',
      },
      negative: {
        backgroundColor: 'red.20',
      },
    },
  }),
  sx
);

export const SemanticDrawerHeader = ({ type, children, sx }) => {
  return (
    <StyledSemanticDrawerHeader type={type} sx={sx}>
      {children}
    </StyledSemanticDrawerHeader>
  );
};
